import React, { useState, useEffect, useRef } from 'react';
import { LogOut, Key } from 'lucide-react';
import { ThemeToggle } from './ui/ThemeToggle';
import { Button } from './ui/button';
import ChangePasswordModal from './ChangePasswordModal';

function UserProfilePopup({ user, roleLabel, theme, onThemeChange, onSignOut, onClose }) {
  const popupRef = useRef(null);
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    const handleOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('pointerdown', handleOutside);
    return () => document.removeEventListener('pointerdown', handleOutside);
  }, [onClose]);

  const displayName = user?.attributes?.name || user?.attributes?.email || user?.username || '—';
  const email = user?.attributes?.email || '';

  return (
    <>
      <div
        ref={popupRef}
        data-testid="user-profile-popup"
        className="absolute bottom-[calc(100%+8px)] left-0 w-[220px] bg-navy-mid border border-white/[0.08] rounded-card shadow-[0_8px_24px_rgba(0,0,0,0.30)] z-modal overflow-hidden"
      >
        {/* User info */}
        <div className="px-3.5 py-3 border-b border-white/[0.07]">
          <p className="text-body font-semibold text-text-primary">{displayName}</p>
          {email && email !== displayName && (
            <p className="text-caption text-text-muted mt-0.5">{email}</p>
          )}
          <p className="text-caption text-aqua mt-0.5">{roleLabel}</p>
        </div>

        {/* Theme toggle */}
        <div className="px-3.5 py-2.5 border-b border-white/[0.07]">
          <p className="text-overline uppercase text-text-muted mb-2">Theme</p>
          <ThemeToggle theme={theme} onChange={onThemeChange} />
        </div>

        {/* Change password */}
        <Button
          variant="ghost"
          onClick={() => setShowChangePassword(true)}
          className="w-full justify-start gap-2 rounded-none px-3.5 py-2.5 h-auto text-text-secondary hover:text-text-primary hover:bg-white/[0.04] border-b border-white/[0.07]"
        >
          <Key className="h-4 w-4" />
          Change password
        </Button>

        {/* Sign out */}
        <Button
          data-testid="popup-signout-btn"
          variant="ghost"
          onClick={onSignOut}
          className="w-full justify-start gap-2 rounded-none px-3.5 py-2.5 h-auto text-text-secondary hover:text-text-primary hover:bg-white/[0.04]"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </Button>
      </div>

      <ChangePasswordModal
        open={showChangePassword}
        onOpenChange={setShowChangePassword}
      />
    </>
  );
}

export default UserProfilePopup;
